export const PATH_TAXES = "/member/taxes";
export const PATH_TAXES_SENT_TO_IRS = "/member/taxes/sent-to-irs";
export const PATH_TAXES_EDIT_TAX_RATE = "/member/taxes/edit/tax-rate";
export const PATH_TAXES_EDIT_TAX_PROFILE = "/member/taxes/edit/tax-profile";
export const PATH_TAXES_SURVEY = "/member/taxes/survey";
